import { useQuery } from "react-query"
import { getApprovedPaymentSummaries } from "./paymentSummaryApi"

export const useApprovedPaymentSummariesQuery = (jobId: number) => {
  return useQuery(['approved-payment-summaries', { jobId }], {
    queryFn: () => getApprovedPaymentSummaries(jobId),
    enabled: !!jobId,
    refetchOnWindowFocus: false,
    staleTime: 30000
  })
}
